module.exports = __webpack_public_path__ + "static/assets/5d308ce375ea6edae5abf4e33eda07f3.svg";